import { TOGGLE_AUTH_POPUP } from "../../domains/authentication/store/actions";
import store from "../../store";
import { SHOW_TOAST_MESSAGE } from "../store/actions";

class AuthHelper {
    static check(ms) {
        if (
            store.getters.customer != undefined &&
            store.getters.customer.id != undefined
        )
            return true;
        else {}
    }

    static checkAuthForAction(context) {
        if (
            context.getters.customer == undefined ||
            context.getters.customer.id == undefined
        ) {
            context.dispatch(SHOW_TOAST_MESSAGE, {
                severity: "warn",
                detail: "Please Register !",
                life: 3000,
            });
            context.dispatch(TOGGLE_AUTH_POPUP, true);

            return false;
        }
        return true;
    }
}

export default AuthHelper;